module.exports = __webpack_public_path__ + "static/media/(V)_MG_5413_-_Pro-Natura_-_Moda_Feminina.39945118.jpg";